/*
 * SPDX-FileCopyrightText: 2023 CERN.
 * SPDX-License-Identifier: MIT
 */

/**
 * Add here all the overridden components of your app.
 */

export const overriddenComponents = {}
